import { Component, Input } from '@angular/core';

@Component({
  selector: 'ns-help',
  template: require('./help.component.html')
})
export class HelpComponent {
  @Input() isRobo;

  ngAfterViewInit() {
    // Tell live person chat that the page has refreshed to force injection
    this.tryAmount = 0;
    this._callLP();
  }

  _callLP() {
    setTimeout(() => {
      if (window.lpTag !== undefined && typeof window.lpTag.newPage === 'function') {
        this.lpLoaded = true;
        window.lpTag.newPage(document.URL);
      } else {
        this.lpLoaded = false;
        // Retry logic
        if (this.tryAmount < 10) {
          this.tryAmount++;
          this._callLP();
        }
      }
    }, 500);
  }
}
